<template>
  <div class="colorsCont">
    <div class="colorsCont-header">
      <p>{{ contLabel }}</p>
      <p>{{ priceLabel }}</p>
    </div>
    <ColorCard
      v-for="(item, i) in colors"
      :key="i"
      :isActive="item.id == currColor && true"
      :colorId="item.id"
      :colorDesignation="item.designation"
      :colorImg="item.chip"
      :colorPrice="item.price"
      :factoryCode="item.factoryCode"
      @color-selected="handleSelectColor($event, item.price, item.type)"
    />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ColorCard from "../../Cards/ColorsCard/ColorCard.vue";

export default {
  name: "Colors",
  components: { ColorCard },
  props: {
    contLabel: { type: String, default: "Cores" },
    currColor: { type: [Number, String] },
    colors: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  mounted() {
    this.setStarterPrice();
  },
  data() {
    return {
      price: 0,
      priceLabel: 0,
    };
  },
  computed: {
    ...mapGetters({
      boLabels: "dataBO/getBoLabels",
    }),
  },
  methods: {
    setPriceLabel(price) {
      if (typeof price !== 'number' || isNaN(price)) price = 0

      let msg = `+ ${parseFloat(price).toFixed(2)} €`;
      const label = this.boLabels?.colorsIva || "c/ IVA";

      return price > 0 ? `${msg} ${label}` : msg;
    },
    handleSelectColor(e, price, type) {
      if (e) {
        this.price = price ? price : 0;
        this.priceLabel = this.setPriceLabel(price, type);
      }
      this.$emit("update:colorType", e);
    },
    setStarterPrice() {
      let colPrice = this.colors.find((el) => el.id == this.currColor)?.price;
      if (colPrice) {
        this.price = Math.ceil(colPrice);
      }
      this.priceLabel = this.setPriceLabel(colPrice);


      if (this.showPrice == false) {
        let cP = this.colors?.[0].price;
        this.price = Math.ceil(cP);
        this.priceLabel = this.setPriceLabel(cP);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.colorsCont {
  display: flex;
  flex-flow: row wrap;

  &:not(:last-child) {
    margin-bottom: 1.5rem;
  }

  &-header {
    flex-basis: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 0.5rem;
    border-bottom: 1px solid $grayLighterCol;
    margin-bottom: 1.5rem;

    & > :first-child {
      color: $grayDarkCol;
    }
    & > :nth-child(2) {
      color: $grayCol;
    }
  }

  & > *:not(:first-child) {
    flex-basis: auto;
    margin-right: 1rem;
    margin-bottom: 1rem;
  }
}
</style>
